import React from "react";
import { Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minWidth: 0,
    overflow: "hidden",
    borderRadius: 20,
    background: "linear-gradient(145deg,rgba(14,25,48,.91),rgba(8,16,31,.97))",
    border: "1px solid rgba(101,121,165,.15)",
    boxShadow: "0 14px 34px rgba(0,0,0,.15)",
    transition: "transform .23s ease, border-color .23s ease, box-shadow .23s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      borderColor: "rgba(22,139,255,.30)",
      boxShadow: "0 21px 44px rgba(0,0,0,.22)",
    },
  },
  media: {
    position: "relative",
    aspectRatio: "16 / 9",
    overflow: "hidden",
    background: "#091326",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform .35s ease",
    "$card:hover &": { transform: "scale(1.03)" },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
    padding: 20,
  },
  meta: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 7,
    marginBottom: 11,
    color: "#6fb8ff",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: theme.direction === "rtl" ? 0 : ".07em",
    textTransform: theme.direction === "rtl" ? "none" : "uppercase",
  },
  metaDot: { color: "#47566e" },
  title: {
    color: "#f4f7fb",
    fontWeight: 850,
    fontSize: "clamp(1.15rem,2vw,1.45rem)",
    lineHeight: 1.5,
    marginBottom: 10,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  desc: {
    color: "#8f9db2",
    fontSize: 12.5,
    lineHeight: 1.88,
    marginBottom: 16,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    marginTop: "auto",
  },
  tag: {
    height: 26,
    color: "#a9bad0",
    fontSize: 9,
    background: "rgba(22,139,255,.045)",
    border: "1px solid rgba(22,139,255,.12)",
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    width: "fit-content",
    marginTop: 18,
    color: "#2999ff",
    fontSize: 10.5,
    fontWeight: 800,
    transition: "color .2s ease, transform .2s ease",
    "&:hover": {
      color: "#73bcff",
      transform: theme.direction === "rtl" ? "translateX(-2px)" : "translateX(2px)",
    },
  },
  icon: {
    transform: theme.direction === "rtl" ? "scaleX(-1)" : "none",
  },
}));

export default function Blog({ item, readLabel }) {
  const classes = useStyles();

  return (
    <article className={classes.card}>
      <a href={item.href} target="_blank" rel="noopener noreferrer" className={classes.media} aria-label={item.title}>
        <img src={item.image} alt={item.title} className={classes.image} loading="lazy" />
      </a>

      <div className={classes.body}>
        <div className={classes.meta}>
          <span>{item.source}</span>
          <span className={classes.metaDot}>•</span>
          <span>{item.readTime}</span>
        </div>

        <Typography component="h2" className={classes.title}>{item.title}</Typography>
        <div className={classes.desc}>{item.desc}</div>

        <div className={classes.tags}>
          {item.tags.map((tag) => (
            <Chip key={tag} label={tag} variant="outlined" className={classes.tag} />
          ))}
        </div>

        <a href={item.href} target="_blank" rel="noopener noreferrer" className={classes.link}>
          <span>{readLabel}</span><LaunchIcon className={classes.icon} fontSize="small" />
        </a>
      </div>
    </article>
  );
}
